/**
 * Spiegelt `App\Enums\ERole` aus dem Backend (siehe
 * `backend/app/Enums/ERole.php`). GoldApp kennt genau zwei Rollen.
 */
export enum Role {
  STAFF = 'staff',
  CUSTOMER = 'customer',
}
